export const PROJECTS = [
  // ─── Graphic Design (20) ───
  {
    id: 1,
    title: 'Graphic Design',
    category: 'graphic',
    image: 'https://lh3.googleusercontent.com/d/1srjZOOOR6c32r0-Tyj4dGeCF4_P91B5b',
    description: 'Complete brand identity for a tech startup, including logo, stationery, and brand guidelines.',
    tags: ['Branding', 'Logo', 'Typography', 'Identity'],
  },
  {
    id: 2,
    title: 'Graphic Design',
    category: 'graphic',
    image: 'https://lh3.googleusercontent.com/d/199Uqcpu9wdEU1iJnMtiJ6AF6v_GKRBJg',
    description: 'Magazine layout & editorial design for a lifestyle publication, focusing on clean typography and visual storytelling.',
    tags: ['Editorial', 'Layout', 'Typography', 'Print'],
  },
  {
    id: 3,
    title: 'Graphic Design',
    category: 'graphic',
    image: 'https://lh3.googleusercontent.com/d/1CQ28tD7mr-aS8oXZnmhydIrP1GnBwGMN',
    description: 'Award-winning minimalist poster design series exploring form, color, and negative space.',
    tags: ['Poster', 'Minimal', 'Typography', 'Design'],
  },
  {
    id: 4,
    title: 'Graphic Design',
    category: 'graphic',
    image: 'https://lh3.googleusercontent.com/d/1lo8HRhUfbIiLJI1igz25DnHhcVdAiMsz',
    description: 'Sustainable packaging design for an eco‑friendly skincare brand, using recycled materials and natural tones.',
    tags: ['Packaging', 'Sustainable', 'Branding', 'Product'],
  },
  {
    id: 5,
    title: 'Graphic Design',
    category: 'graphic',
    image: 'https://lh3.googleusercontent.com/d/1Zh2Ty3bl3WYex9Q7w60MSI3ozLS8cnTP',
    description: 'A self‑published zine documenting street art culture in Berlin, with bold typography and experimental layouts.',
    tags: ['Zine', 'Street Art', 'Layout', 'Urban'],
  },
  {
    id: 6,
    title: 'Graphic Design',
    category: 'graphic',
    image: 'https://lh3.googleusercontent.com/d/1zUG7x0ZJnb_WtH7PM_Rdq_fRUEopXEVo',
    description: 'User interface design for a SaaS platform, focusing on clarity, accessibility, and modern aesthetics.',
    tags: ['UI', 'Web', 'UX', 'SaaS'],
  },
  {
    id: 7,
    title: 'Graphic Design',
    category: 'graphic',
    image: 'https://lh3.googleusercontent.com/d/1PG_iVm1aXThxGMRG23wUmSrGJErBj989',
    description: 'Rebranding of a record store chain, blending retro and contemporary design elements.',
    tags: ['Rebrand', 'Retro', 'Logo', 'Typography'],
  },
  {
    id: 8,
    title: 'Graphic Design',
    category: 'graphic',
    image: 'https://lh3.googleusercontent.com/d/1IQdDIt2X9o1woIybhjt71zIO0_jcogzK',
    description: 'Informative infographic visualizing climate data, designed for a non‑profit campaign.',
    tags: ['Infographic', 'Data', 'Non‑profit', 'Editorial'],
  },
  {
    id: 9,
    title: 'Graphic Design',
    category: 'graphic',
    image: 'https://lh3.googleusercontent.com/d/1sFVcB6_hgH-3osAcTdAsOZIJ6lt3urxb',
    description: 'A curated mood board for a luxury interior design project, featuring color palettes and material samples.',
    tags: ['Mood Board', 'Interior', 'Style', 'Inspiration'],
  },
  {
    id: 10,
    title: 'Graphic Design',
    category: 'graphic',
    image: 'https://lh3.googleusercontent.com/d/18CZSOZTXrCBHJh94SQQ6GG7XFJClJGin',
    description: 'Cover design for a book on typography history, using classic typefaces and modern composition.',
    tags: ['Book Cover', 'Typography', 'Editorial', 'Design'],
  },
  {
    id: 11,
    title: 'Graphic Design',
    category: 'graphic',
    image: 'https://lh3.googleusercontent.com/d/1m-Ny0u6VTfCTgxJ9ncgmfM7UH8u0GXvg',
    description: 'Cover design for a book on typography history, using classic typefaces and modern composition.',
    tags: ['Book Cover', 'Typography', 'Editorial', 'Design'],
  },
  {
    id: 12,
    title: 'Graphic Design',
    category: 'graphic',
    image: 'https://lh3.googleusercontent.com/d/1Ownge2KJ4nP1xx012ocPPWKvhEPAUmKT',
    description: 'Cover design for a book on typography history, using classic typefaces and modern composition.',
    tags: ['Book Cover', 'Typography', 'Editorial', 'Design'],
  },
  {
    id: 13,
    title: 'Graphic Design',
    category: 'graphic',
    image: 'https://lh3.googleusercontent.com/d/1mS-GO8H7TjN_E7WIVQSCUCBntfolD_zY',
    description: 'Cover design for a book on typography history, using classic typefaces and modern composition.',
    tags: ['Book Cover', 'Typography', 'Editorial', 'Design'],
  },
  {
    id: 14,
    title: 'Graphic Design',
    category: 'graphic',
    image: 'https://lh3.googleusercontent.com/d/1uT01HTN6YiAiWsky1-YazHydQbmcimtr',
    description: 'Cover design for a book on typography history, using classic typefaces and modern composition.',
    tags: ['Book Cover', 'Typography', 'Editorial', 'Design'],
  },
  {
    id: 15,
    title: 'Graphic Design',
    category: 'graphic',
    image: 'https://lh3.googleusercontent.com/d/1d8sNfuAkbOFr214N_ZdYEaEGEdqjisB2',
    description: 'Cover design for a book on typography history, using classic typefaces and modern composition.',
    tags: ['Book Cover', 'Typography', 'Editorial', 'Design'],
  },
  {
    id: 16,
    title: 'Graphic Design',
    category: 'graphic',
    image: 'https://lh3.googleusercontent.com/d/1fTTxwVj7iHRDZ0wI49qsVeFDs6aHklLi',
    description: 'Cover design for a book on typography history, using classic typefaces and modern composition.',
    tags: ['Book Cover', 'Typography', 'Editorial', 'Design'],
  },
  {
    id: 17,
    title: 'Graphic Design',
    category: 'graphic',
    image: 'https://lh3.googleusercontent.com/d/1P-1voAm77yGpPLHlM6oa4jxqck9wmmIX',
    description: 'Cover design for a book on typography history, using classic typefaces and modern composition.',
    tags: ['Book Cover', 'Typography', 'Editorial', 'Design'],
  },
  {
    id: 18,
    title: 'Graphic Design',
    category: 'graphic',
    image: 'https://lh3.googleusercontent.com/d/1_WcJljeqC3G38p0PQJ-NtUHZzQovnonD',
    description: 'Cover design for a book on typography history, using classic typefaces and modern composition.',
    tags: ['Book Cover', 'Typography', 'Editorial', 'Design'],
  },
  {
    id: 19,
    title: 'Graphic Design',
    category: 'graphic',
    image: 'https://lh3.googleusercontent.com/d/1C50eNCdtChNngJoT5RYN68aWkiYApOVq',
    description: 'Cover design for a book on typography history, using classic typefaces and modern composition.',
    tags: ['Book Cover', 'Typography', 'Editorial', 'Design'],
  },
  {
    id: 20,
    title: 'Graphic Design',
    category: 'graphic',
    image: 'https://lh3.googleusercontent.com/d/1qJsr7Kj233WnRMcVJgd-VAVRmjZLU-VW',
    description: 'Cover design for a book on typography history, using classic typefaces and modern composition.',
    tags: ['Book Cover', 'Typography', 'Editorial', 'Design'],
  },

  // ─── Videography (38) ───
  {
    id: 21,
    title: 'Urban Dreams — Short Film',
    category: 'video',
    subcategory: 'corporate',
    image: 'https://lh3.googleusercontent.com/d/1dC9OultUVtn2Xh890L2VWoLEmvF6_cLH',
    description: 'A cinematic short film exploring the rhythm and energy of city life through visual storytelling.',
    tags: ['Cinematography', 'Editing', 'Color Grading', 'Directing'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1dC9OultUVtn2Xh890L2VWoLEmvF6_cLH',
        embed: 'https://drive.google.com/file/d/1dC9OultUVtn2Xh890L2VWoLEmvF6_cLH/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 22,
    title: 'Urban Dreams — Short Film',
    category: 'video',
    subcategory: 'real-estate',
    image: 'https://lh3.googleusercontent.com/d/1Sz84cV6zrnVlWtkA1CwNh1-xD-Bq4Od9',
    description: 'A cinematic short film exploring the rhythm and energy of city life through visual storytelling.',
    tags: ['Cinematography', 'Editing', 'Color Grading', 'Directing'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1Sz84cV6zrnVlWtkA1CwNh1-xD-Bq4Od9',
        embed: 'https://drive.google.com/file/d/1Sz84cV6zrnVlWtkA1CwNh1-xD-Bq4Od9/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 23,
    title: 'Urban Dreams — Short Film',
    category: 'video',
    subcategory: 'politics',
    image: 'https://lh3.googleusercontent.com/d/12HKNBIdtnnompwReI0wWof3kFMJnO-Fo',
    description: 'A cinematic short film exploring the rhythm and energy of city life through visual storytelling.',
    tags: ['Cinematography', 'Editing', 'Color Grading', 'Directing'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/12HKNBIdtnnompwReI0wWof3kFMJnO-Fo',
        embed: 'https://drive.google.com/file/d/12HKNBIdtnnompwReI0wWof3kFMJnO-Fo/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 24,
    title: 'Urban Dreams — Short Film',
    category: 'video',
    subcategory: 'politics',
    image: 'https://lh3.googleusercontent.com/d/1qg3ZRTSxWc9a1BTCY1qPkN9oAkpfjhtQ',
    description: 'A cinematic short film exploring the rhythm and energy of city life through visual storytelling.',
    tags: ['Cinematography', 'Editing', 'Color Grading', 'Directing'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1qg3ZRTSxWc9a1BTCY1qPkN9oAkpfjhtQ',
        embed: 'https://drive.google.com/file/d/1qg3ZRTSxWc9a1BTCY1qPkN9oAkpfjhtQ/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 25,
    title: 'Urban Dreams — Short Film',
    category: 'video',
    subcategory: 'podcast',
    image: 'https://lh3.googleusercontent.com/d/1hTdznTscWarOeW-y4P9ka6fmNf8t98qy',
    description: 'A cinematic short film exploring the rhythm and energy of city life through visual storytelling.',
    tags: ['Cinematography', 'Editing', 'Color Grading', 'Directing'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1hTdznTscWarOeW-y4P9ka6fmNf8t98qy',
        embed: 'https://drive.google.com/file/d/1hTdznTscWarOeW-y4P9ka6fmNf8t98qy/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 26,
    title: 'Urban Dreams — Short Film',
    category: 'video',
    subcategory: 'podcast',
    image: 'https://lh3.googleusercontent.com/d/17OapPMxJk_8ML5WCZ9eyvE9qUCIb0ISZ',
    description: 'A cinematic short film exploring the rhythm and energy of city life through visual storytelling.',
    tags: ['Cinematography', 'Editing', 'Color Grading', 'Directing'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/17OapPMxJk_8ML5WCZ9eyvE9qUCIb0ISZ',
        embed: 'https://drive.google.com/file/d/17OapPMxJk_8ML5WCZ9eyvE9qUCIb0ISZ/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 27,
    title: 'Ethereal Music Video',
    category: 'video',
    subcategory: 'wedding',
    image: 'https://lh3.googleusercontent.com/d/1azpFmYnimlfsNXwIWPfGr15FMVzBs24y',
    description: 'Music video for an independent artist, blending abstract visuals with live performance footage.',
    tags: ['Direction', 'VFX', 'Editing', 'Color Grading'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1azpFmYnimlfsNXwIWPfGr15FMVzBs24y',
        embed: 'https://drive.google.com/file/d/1azpFmYnimlfsNXwIWPfGr15FMVzBs24y/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 28,
    title: 'Ethereal Music Video',
    category: 'video',
    subcategory: 'wedding',
    image: 'https://lh3.googleusercontent.com/d/1Ymrhac6YI19_NpUfmu8MOsGkNLmhhQNe',
    description: 'Music video for an independent artist, blending abstract visuals with live performance footage.',
    tags: ['Direction', 'VFX', 'Editing', 'Color Grading'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1Ymrhac6YI19_NpUfmu8MOsGkNLmhhQNe',
        embed: 'https://drive.google.com/file/d/1Ymrhac6YI19_NpUfmu8MOsGkNLmhhQNe/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 29,
    title: 'Ethereal Music Video',
    category: 'video',
    subcategory: 'wedding',
    image: 'https://lh3.googleusercontent.com/d/1zaau1MP3b9C0qWLmFt03Y13SWDUSj4Kt',
    description: 'Music video for an independent artist, blending abstract visuals with live performance footage.',
    tags: ['Direction', 'VFX', 'Editing', 'Color Grading'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1zaau1MP3b9C0qWLmFt03Y13SWDUSj4Kt',
        embed: 'https://drive.google.com/file/d/1zaau1MP3b9C0qWLmFt03Y13SWDUSj4Kt/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 30,
    title: 'Ethereal Music Video',
    category: 'video',
    subcategory: 'wedding',
    image: 'https://lh3.googleusercontent.com/d/18gq1ayi0EGNU_eLPR5yVvavPDPSp5CP5',
    description: 'Music video for an independent artist, blending abstract visuals with live performance footage.',
    tags: ['Direction', 'VFX', 'Editing', 'Color Grading'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/18gq1ayi0EGNU_eLPR5yVvavPDPSp5CP5',
        embed: 'https://drive.google.com/file/d/18gq1ayi0EGNU_eLPR5yVvavPDPSp5CP5/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 31,
    title: 'Ethereal Music Video',
    category: 'video',
    subcategory: 'wedding',
    image: 'https://lh3.googleusercontent.com/d/1G4u1cWzcfHstbNrRA3c1AsH3h5Z1ij4h',
    description: 'Music video for an independent artist, blending abstract visuals with live performance footage.',
    tags: ['Direction', 'VFX', 'Editing', 'Color Grading'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1G4u1cWzcfHstbNrRA3c1AsH3h5Z1ij4h',
        embed: 'https://drive.google.com/file/d/1G4u1cWzcfHstbNrRA3c1AsH3h5Z1ij4h/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 32,
    title: 'Ethereal Music Video',
    category: 'video',
    subcategory: 'wedding',
    image: 'https://lh3.googleusercontent.com/d/1BIr22_AcCSxCImpK72Cw1wYmWgvuLRxJ',
    description: 'Music video for an independent artist, blending abstract visuals with live performance footage.',
    tags: ['Direction', 'VFX', 'Editing', 'Color Grading'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1BIr22_AcCSxCImpK72Cw1wYmWgvuLRxJ',
        embed: 'https://drive.google.com/file/d/1BIr22_AcCSxCImpK72Cw1wYmWgvuLRxJ/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 33,
    title: 'Wanderlust — Travel Documentary',
    category: 'video',
    subcategory: 'social',
    image: 'https://lh3.googleusercontent.com/d/1GZeTiDfBnRz2LM8BaA_h7RMIztRv8R_6',
    description: 'Documentary exploring remote landscapes and the people who call them home.',
    tags: ['Documentary', 'Cinematography', 'Sound Design', 'Editing'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1GZeTiDfBnRz2LM8BaA_h7RMIztRv8R_6',
        embed: 'https://drive.google.com/file/d/1GZeTiDfBnRz2LM8BaA_h7RMIztRv8R_6/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 34,
    title: 'Brand Film — Lumina',
    category: 'video',
    subcategory: 'corporate',
    image: 'https://lh3.googleusercontent.com/d/16VEj7qvBlc4shAPB7lQEuJVrzlH6Gbsa',
    description: 'A cinematic brand film for a tech company, highlighting innovation and human connection.',
    tags: ['Brand Film', 'Cinematography', 'Storytelling', 'Editing'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/16VEj7qvBlc4shAPB7lQEuJVrzlH6Gbsa',
        embed: 'https://drive.google.com/file/d/16VEj7qvBlc4shAPB7lQEuJVrzlH6Gbsa/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 35,
    title: 'Dance Performance — Live Recording',
    category: 'video',
    subcategory: 'social',
    image: 'https://lh3.googleusercontent.com/d/1GSqhq-no-zoweYzuRJ7tmcPcZwHJx8Pv',
    description: 'Live recording of a contemporary dance performance, capturing movement and emotion.',
    tags: ['Live Performance', 'Cinematography', 'Editing', 'Sound'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1GSqhq-no-zoweYzuRJ7tmcPcZwHJx8Pv',
        embed: 'https://drive.google.com/file/d/1GSqhq-no-zoweYzuRJ7tmcPcZwHJx8Pv/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 36,
    title: 'Commercial — Organic Food',
    category: 'video',
    subcategory: 'social-media',
    image: 'https://lh3.googleusercontent.com/d/10fQeGkF7pAn8P4IUV8EJk-4WrbicS33o',
    description: 'A mouth‑watering commercial for an organic food brand, shot in natural daylight.',
    tags: ['Commercial', 'Food', 'Cinematography', 'Editing'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/10fQeGkF7pAn8P4IUV8EJk-4WrbicS33o',
        embed: 'https://drive.google.com/file/d/10fQeGkF7pAn8P4IUV8EJk-4WrbicS33o/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 37,
    title: 'Fashion Lookbook — Spring Collection',
    category: 'video',
    subcategory: 'social-media',
    image: 'https://lh3.googleusercontent.com/d/1TngDq7EJ0f8vGPumO2ckkyS6viphzFPT',
    description: 'A dynamic lookbook video showcasing a fashion brand’s spring collection, with slow motion and vibrant colors.',
    tags: ['Fashion', 'Lookbook', 'Cinematography', 'Editing'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1TngDq7EJ0f8vGPumO2ckkyS6viphzFPT',
        embed: 'https://drive.google.com/file/d/1TngDq7EJ0f8vGPumO2ckkyS6viphzFPT/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 38,
    title: 'Travel Vlog — Japan',
    category: 'video',
    subcategory: 'social-media',
    image: 'https://lh3.googleusercontent.com/d/13BhAbJ84dU5gvBdaGmMTJ9Vub8hbLqEG',
    description: 'A personal travel vlog documenting a journey through Japan, capturing culture, food, and scenery.',
    tags: ['Travel', 'Vlog', 'Editing', 'Cinematography'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/13BhAbJ84dU5gvBdaGmMTJ9Vub8hbLqEG',
        embed: 'https://drive.google.com/file/d/13BhAbJ84dU5gvBdaGmMTJ9Vub8hbLqEG/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 39,
    title: 'Travel Vlog — Japan',
    category: 'video',
    subcategory: 'social-media',
    image: 'https://lh3.googleusercontent.com/d/1GooFFjOYwHgYYtMIEf_hI03hxVINTWkk',
    description: 'A personal travel vlog documenting a journey through Japan, capturing culture, food, and scenery.',
    tags: ['Travel', 'Vlog', 'Editing', 'Cinematography'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1GooFFjOYwHgYYtMIEf_hI03hxVINTWkk',
        embed: 'https://drive.google.com/file/d/1GooFFjOYwHgYYtMIEf_hI03hxVINTWkk/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 40,
    title: 'Promo — Tech Conference',
    category: 'video',
    subcategory: 'corporate',
    image: 'https://lh3.googleusercontent.com/d/1wEs9iN4Jj6v50FQAhefZNQIrXiAxPPOt',
    description: 'Promotional video for a tech conference, with fast‑paced editing and speaker highlights.',
    tags: ['Promo', 'Event', 'Editing', 'Motion Graphics'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1wEs9iN4Jj6v50FQAhefZNQIrXiAxPPOt',
        embed: 'https://drive.google.com/file/d/1wEs9iN4Jj6v50FQAhefZNQIrXiAxPPOt/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 41,
    title: 'Promo — Tech Conference',
    category: 'video',
    subcategory: 'corporate',
    image: 'https://lh3.googleusercontent.com/d/1ZYmSvrJCAS6hJgPVGIClLi9g3iq-t408',
    description: 'Promotional video for a tech conference, with fast‑paced editing and speaker highlights.',
    tags: ['Promo', 'Event', 'Editing', 'Motion Graphics'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1ZYmSvrJCAS6hJgPVGIClLi9g3iq-t408',
        embed: 'https://drive.google.com/file/d/1ZYmSvrJCAS6hJgPVGIClLi9g3iq-t408/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 42,
    title: 'Promo — Tech Conference',
    category: 'video',
    subcategory: 'corporate',
    image: 'https://lh3.googleusercontent.com/d/1aG-258_azFs5ZMxKb0JkFxLYhURWMkNr',
    description: 'Promotional video for a tech conference, with fast‑paced editing and speaker highlights.',
    tags: ['Promo', 'Event', 'Editing', 'Motion Graphics'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1aG-258_azFs5ZMxKb0JkFxLYhURWMkNr',
        embed: 'https://drive.google.com/file/d/1aG-258_azFs5ZMxKb0JkFxLYhURWMkNr/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 43,
    title: 'Promo — Tech Conference',
    category: 'video',
    subcategory: 'corporate',
    image: 'https://lh3.googleusercontent.com/d/1jydAkJ_iAbB0jjQrNNH5M4MfigX9VkVO',
    description: 'Promotional video for a tech conference, with fast‑paced editing and speaker highlights.',
    tags: ['Promo', 'Event', 'Editing', 'Motion Graphics'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1jydAkJ_iAbB0jjQrNNH5M4MfigX9VkVO',
        embed: 'https://drive.google.com/file/d/1jydAkJ_iAbB0jjQrNNH5M4MfigX9VkVO/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 44,
    title: 'Promo — Tech Conference',
    category: 'video',
    subcategory: 'corporate',
    image: 'https://lh3.googleusercontent.com/d/1iDW3ADLLgs0MD658KYru8tgDBFagFuWL',
    description: 'Promotional video for a tech conference, with fast‑paced editing and speaker highlights.',
    tags: ['Promo', 'Event', 'Editing', 'Motion Graphics'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1iDW3ADLLgs0MD658KYru8tgDBFagFuWL',
        embed: 'https://drive.google.com/file/d/1iDW3ADLLgs0MD658KYru8tgDBFagFuWL/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 45,
    title: 'Promo — Tech Conference',
    category: 'video',
    subcategory: 'corporate',
    image: 'https://lh3.googleusercontent.com/d/1zTZ-OieEw4tTRDMBLhRY2qrjMKpvLpY9',
    description: 'Promotional video for a tech conference, with fast‑paced editing and speaker highlights.',
    tags: ['Promo', 'Event', 'Editing', 'Motion Graphics'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1zTZ-OieEw4tTRDMBLhRY2qrjMKpvLpY9',
        embed: 'https://drive.google.com/file/d/1zTZ-OieEw4tTRDMBLhRY2qrjMKpvLpY9/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 46,
    title: 'Promo — Tech Conference',
    category: 'video',
    subcategory: 'corporate',
    image: 'https://lh3.googleusercontent.com/d/1DiO0Ff_mkNTZYpkqFW2hQm1LVWDXw4_E',
    description: 'Promotional video for a tech conference, with fast‑paced editing and speaker highlights.',
    tags: ['Promo', 'Event', 'Editing', 'Motion Graphics'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1DiO0Ff_mkNTZYpkqFW2hQm1LVWDXw4_E',
        embed: 'https://drive.google.com/file/d/1DiO0Ff_mkNTZYpkqFW2hQm1LVWDXw4_E/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 47,
    title: 'Promo — Tech Conference',
    category: 'video',
    subcategory: 'corporate',
    image: 'https://lh3.googleusercontent.com/d/1_ETM5XqrWCQXvfe2mBpcOQvf1rZTkFj2',
    description: 'Promotional video for a tech conference, with fast‑paced editing and speaker highlights.',
    tags: ['Promo', 'Event', 'Editing', 'Motion Graphics'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1_ETM5XqrWCQXvfe2mBpcOQvf1rZTkFj2',
        embed: 'https://drive.google.com/file/d/1_ETM5XqrWCQXvfe2mBpcOQvf1rZTkFj2/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 48,
    title: 'Promo — Tech Conference',
    category: 'video',
    subcategory: 'corporate',
    image: 'https://lh3.googleusercontent.com/d/1SgSV0m9pegfud1UskwQyy3eNGk4V90uZ',
    description: 'Promotional video for a tech conference, with fast‑paced editing and speaker highlights.',
    tags: ['Promo', 'Event', 'Editing', 'Motion Graphics'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1SgSV0m9pegfud1UskwQyy3eNGk4V90uZ',
        embed: 'https://drive.google.com/file/d/1SgSV0m9pegfud1UskwQyy3eNGk4V90uZ/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 49,
    title: 'Promo — Tech Conference',
    category: 'video',
    subcategory: 'corporate',
    image: 'https://lh3.googleusercontent.com/d/1p3mkSeodZ3S3i3XZK5ZorQTvHe-bnOGO',
    description: 'Promotional video for a tech conference, with fast‑paced editing and speaker highlights.',
    tags: ['Promo', 'Event', 'Editing', 'Motion Graphics'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1p3mkSeodZ3S3i3XZK5ZorQTvHe-bnOGO',
        embed: 'https://drive.google.com/file/d/1p3mkSeodZ3S3i3XZK5ZorQTvHe-bnOGO/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 50,
    title: 'Promo — Tech Conference',
    category: 'video',
    subcategory: 'corporate',
    image: 'https://lh3.googleusercontent.com/d/1m3bbS9cfqxttEL0aOhDRvthetIGJbo25',
    description: 'Promotional video for a tech conference, with fast‑paced editing and speaker highlights.',
    tags: ['Promo', 'Event', 'Editing', 'Motion Graphics'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1m3bbS9cfqxttEL0aOhDRvthetIGJbo25',
        embed: 'https://drive.google.com/file/d/1m3bbS9cfqxttEL0aOhDRvthetIGJbo25/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 51,
    title: 'Promo — Tech Conference',
    category: 'video',
    subcategory: 'social',
    image: 'https://lh3.googleusercontent.com/d/1kPrW145JILH24OoGLhwA5Zd1MDVeHjc9',
    description: 'Promotional video for a tech conference, with fast‑paced editing and speaker highlights.',
    tags: ['Promo', 'Event', 'Editing', 'Motion Graphics'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1kPrW145JILH24OoGLhwA5Zd1MDVeHjc9',
        embed: 'https://drive.google.com/file/d/1kPrW145JILH24OoGLhwA5Zd1MDVeHjc9/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 52,
    title: 'Documentary — Ocean Conservation',
    category: 'video',
    subcategory: 'social',
    image: 'https://lh3.googleusercontent.com/d/1j-QW8wAZjLxSGsyGWV6PJYipwLmfog1i',
    description: 'A short documentary highlighting ocean conservation efforts, with underwater footage and expert interviews.',
    tags: ['Documentary', 'Conservation', 'Cinematography', 'Editing'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1j-QW8wAZjLxSGsyGWV6PJYipwLmfog1i',
        embed: 'https://drive.google.com/file/d/1j-QW8wAZjLxSGsyGWV6PJYipwLmfog1i/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 53,
    title: 'Documentary — Ocean Conservation',
    category: 'video',
    subcategory: 'social',
    image: 'https://lh3.googleusercontent.com/d/11McGM7_1tiAAMvFddw5ZdNewIS0yVbNe',
    description: 'A short documentary highlighting ocean conservation efforts, with underwater footage and expert interviews.',
    tags: ['Documentary', 'Conservation', 'Cinematography', 'Editing'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/11McGM7_1tiAAMvFddw5ZdNewIS0yVbNe',
        embed: 'https://drive.google.com/file/d/11McGM7_1tiAAMvFddw5ZdNewIS0yVbNe/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 54,
    title: 'Documentary — Ocean Conservation',
    category: 'video',
    subcategory: 'social',
    image: 'https://lh3.googleusercontent.com/d/1N0RG_tQvCliVa49nceE0DC2aPAJKZqfu',
    description: 'A short documentary highlighting ocean conservation efforts, with underwater footage and expert interviews.',
    tags: ['Documentary', 'Conservation', 'Cinematography', 'Editing'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1N0RG_tQvCliVa49nceE0DC2aPAJKZqfu',
        embed: 'https://drive.google.com/file/d/1N0RG_tQvCliVa49nceE0DC2aPAJKZqfu/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 55,
    title: 'Documentary — Ocean Conservation',
    category: 'video',
    subcategory: 'social',
    image: 'https://lh3.googleusercontent.com/d/1pef39e6dxlo5L3JSDLeZzQXk2r93kTDf',
    description: 'A short documentary highlighting ocean conservation efforts, with underwater footage and expert interviews.',
    tags: ['Documentary', 'Conservation', 'Cinematography', 'Editing'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1pef39e6dxlo5L3JSDLeZzQXk2r93kTDf',
        embed: 'https://drive.google.com/file/d/1pef39e6dxlo5L3JSDLeZzQXk2r93kTDf/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 56,
    title: 'Documentary — Ocean Conservation',
    category: 'video',
    subcategory: 'social',
    image: 'https://lh3.googleusercontent.com/d/1eqKTUDtidXjcqYvIWAi6_bXVuoOCwUGA',
    description: 'A short documentary highlighting ocean conservation efforts, with underwater footage and expert interviews.',
    tags: ['Documentary', 'Conservation', 'Cinematography', 'Editing'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1eqKTUDtidXjcqYvIWAi6_bXVuoOCwUGA',
        embed: 'https://drive.google.com/file/d/1eqKTUDtidXjcqYvIWAi6_bXVuoOCwUGA/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 57,
    title: 'Documentary — Ocean Conservation',
    category: 'video',
    subcategory: 'social',
    image: 'https://lh3.googleusercontent.com/d/1tyn3yirYfBPyku0yE_7EGpyz_lLtboc_',
    description: 'A short documentary highlighting ocean conservation efforts, with underwater footage and expert interviews.',
    tags: ['Documentary', 'Conservation', 'Cinematography', 'Editing'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1tyn3yirYfBPyku0yE_7EGpyz_lLtboc_',
        embed: 'https://drive.google.com/file/d/1tyn3yirYfBPyku0yE_7EGpyz_lLtboc_/preview',
        title: 'Videography',
      },
    ],
  },
  {
    id: 58,
    title: 'Documentary — Ocean Conservation',
    category: 'video',
    subcategory: 'social',
    image: 'https://lh3.googleusercontent.com/d/18F2Cc_t4bQnaQNsuE8YlvCQZTDTmHXSZ',
    description: 'A short documentary highlighting ocean conservation efforts, with underwater footage and expert interviews.',
    tags: ['Documentary', 'Conservation', 'Cinematography', 'Editing'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/18F2Cc_t4bQnaQNsuE8YlvCQZTDTmHXSZ',
        embed: 'https://drive.google.com/file/d/18F2Cc_t4bQnaQNsuE8YlvCQZTDTmHXSZ/preview',
        title: 'Videography',
      },
    ],
  },

  // ─── Photography (53) ───
  {
    id: 59,
    title: 'Photography',
    category: 'photo',
    subcategory: 'corporate',
    image: 'https://lh3.googleusercontent.com/d/1x7TBJvGNI6sd1ADvXuVeal56z2hoZ90T',
    description: 'Complete brand identity for a tech startup, including logo, stationery, and brand guidelines.',
    tags: ['Branding', 'Logo', 'Typography', 'Identity'],
  },
  {
    id: 60,
    title: 'Photography',
    category: 'photo',
    subcategory: 'corporate',
    image: 'https://lh3.googleusercontent.com/d/109x3zUc2zQ5fX95FkS_JFuiQSmOcJmTJ',
    description: 'Complete brand identity for a tech startup, including logo, stationery, and brand guidelines.',
    tags: ['Branding', 'Logo', 'Typography', 'Identity'],
  },
  {
    id: 61,
    title: 'Photography',
    category: 'photo',
    subcategory: 'corporate',
    image: 'https://lh3.googleusercontent.com/d/1XodGSI3qsNtrhuGFJiOoaUdRMoxCnt6_',
    description: 'Complete brand identity for a tech startup, including logo, stationery, and brand guidelines.',
    tags: ['Branding', 'Logo', 'Typography', 'Identity'],
  },
  {
    id: 62,
    title: 'Photography',
    category: 'photo',
    subcategory: 'corporate',
    image: 'https://lh3.googleusercontent.com/d/1D0x4xTIHo114r9BcMyvAcAj2-Va3FRPd',
    description: 'Complete brand identity for a tech startup, including logo, stationery, and brand guidelines.',
    tags: ['Branding', 'Logo', 'Typography', 'Identity'],
  },
  {
    id: 63,
    title: 'Photography',
    category: 'photo',
    subcategory: 'graduation',
    image: 'https://lh3.googleusercontent.com/d/1dgP2WOXaK4JzqCGPweAsmjpkcnnFDDp9',
    description: 'Complete brand identity for a tech startup, including logo, stationery, and brand guidelines.',
    tags: ['Branding', 'Logo', 'Typography', 'Identity'],
  },
  {
    id: 64,
    title: 'Photography',
    category: 'photo',
    subcategory: 'graduation',
    image: 'https://lh3.googleusercontent.com/d/1bYOqS3P3a_4htw7wXTVM2Pyijpi4GdVP',
    description: 'Complete brand identity for a tech startup, including logo, stationery, and brand guidelines.',
    tags: ['Branding', 'Logo', 'Typography', 'Identity'],
  },
  {
    id: 65,
    title: 'Photography',
    category: 'photo',
    subcategory: 'graduation',
    image: 'https://lh3.googleusercontent.com/d/1dgOJcVB5C_Dq0j_cNfrnJfd6EvKdws6J',
    description: 'Complete brand identity for a tech startup, including logo, stationery, and brand guidelines.',
    tags: ['Branding', 'Logo', 'Typography', 'Identity'],
  },
  {
    id: 66,
    title: 'Photography',
    category: 'photo',
    subcategory: 'graduation',
    image: 'https://lh3.googleusercontent.com/d/1X0d3sbbxu3zGjfpmp9nZsmCLjgJ1tGUN',
    description: 'Complete brand identity for a tech startup, including logo, stationery, and brand guidelines.',
    tags: ['Branding', 'Logo', 'Typography', 'Identity'],
  },
  {
    id: 67,
    title: 'Photography',
    category: 'photo',
    subcategory: 'graduation',
    image: 'https://lh3.googleusercontent.com/d/1OP84fEBoevQ_HXRSuelhgIAMKU206XVk',
    description: 'Complete brand identity for a tech startup, including logo, stationery, and brand guidelines.',
    tags: ['Branding', 'Logo', 'Typography', 'Identity'],
  },
  {
    id: 68,
    title: 'Photography',
    category: 'photo',
    subcategory: 'graduation',
    image: 'https://lh3.googleusercontent.com/d/127fcDrmvG8ifk6LYbCnjTeqF1Gy1gaLH',
    description: 'Complete brand identity for a tech startup, including logo, stationery, and brand guidelines.',
    tags: ['Branding', 'Logo', 'Typography', 'Identity'],
  },
  {
    id: 69,
    title: 'Photography',
    category: 'photo',
    subcategory: 'graduation',
    image: 'https://lh3.googleusercontent.com/d/1FsO-JI3iNF4QIW9-WoFHvGdQqlN73pNV',
    description: 'Complete brand identity for a tech startup, including logo, stationery, and brand guidelines.',
    tags: ['Branding', 'Logo', 'Typography', 'Identity'],
  },
  {
    id: 70,
    title: 'Photography',
    category: 'photo',
    subcategory: 'wedding',
    image: 'https://lh3.googleusercontent.com/d/1g4GzS08_XEumwXskbutpMSc8w69sFAvn',
    description: 'Complete brand identity for a tech startup, including logo, stationery, and brand guidelines.',
    tags: ['Branding', 'Logo', 'Typography', 'Identity'],
  },
  {
    id: 71,
    title: 'Photography',
    category: 'photo',
    subcategory: 'wedding',
    image: 'https://lh3.googleusercontent.com/d/1ndkGSo3FcszMzLhIYhG-Fb88Ppwjbi1d',
    description: 'Complete brand identity for a tech startup, including logo, stationery, and brand guidelines.',
    tags: ['Branding', 'Logo', 'Typography', 'Identity'],
  },
  {
    id: 72,
    title: 'Photography',
    category: 'photo',
    subcategory: 'wedding',
    image: 'https://lh3.googleusercontent.com/d/1qWPY5oW86LSfYwNF_tEmQCrjxURM0Fwf',
    description: 'Complete brand identity for a tech startup, including logo, stationery, and brand guidelines.',
    tags: ['Branding', 'Logo', 'Typography', 'Identity'],
  },
  {
    id: 73,
    title: 'Photography',
    category: 'photo',
    subcategory: 'wedding',
    image: 'https://lh3.googleusercontent.com/d/1pmDVazOUPUcMVkPmixxFAKZmJo-LSteg',
    description: 'Complete brand identity for a tech startup, including logo, stationery, and brand guidelines.',
    tags: ['Branding', 'Logo', 'Typography', 'Identity'],
  },
  {
    id: 74,
    title: 'Photography',
    category: 'photo',
    subcategory: 'wedding',
    image: 'https://lh3.googleusercontent.com/d/10Aqp0mIwiVv-_EZuV8SdRSTOqOel0dMm',
    description: 'Complete brand identity for a tech startup, including logo, stationery, and brand guidelines.',
    tags: ['Branding', 'Logo', 'Typography', 'Identity'],
  },
  {
    id: 75,
    title: 'Photography',
    category: 'photo',
    subcategory: 'wedding',
    image: 'https://lh3.googleusercontent.com/d/1IhWVpUpB631XJZFH-j9tpMpCDymbVfja',
    description: 'Complete brand identity for a tech startup, including logo, stationery, and brand guidelines.',
    tags: ['Branding', 'Logo', 'Typography', 'Identity'],
  },
  {
    id: 76,
    title: 'Photography',
    category: 'photo',
    subcategory: 'wedding',
    image: 'https://lh3.googleusercontent.com/d/1eFYwU1iECOAecAltiRQMil6IBwj2g5KC',
    description: 'Complete brand identity for a tech startup, including logo, stationery, and brand guidelines.',
    tags: ['Branding', 'Logo', 'Typography', 'Identity'],
  },
  {
    id: 77,
    title: 'Photography',
    category: 'photo',
    subcategory: 'wedding',
    image: 'https://lh3.googleusercontent.com/d/1azJPqE0ziQ-3twD84blAddCfvmrtGCOM',
    description: 'Complete brand identity for a tech startup, including logo, stationery, and brand guidelines.',
    tags: ['Branding', 'Logo', 'Typography', 'Identity'],
  },
  {
    id: 78,
    title: 'Photography',
    category: 'photo',
    subcategory: 'wedding',
    image: 'https://lh3.googleusercontent.com/d/1yHc7ZkKfumBjI13cjHE-2NefyTM7IIr9',
    description: 'Complete brand identity for a tech startup, including logo, stationery, and brand guidelines.',
    tags: ['Branding', 'Logo', 'Typography', 'Identity'],
  },
  {
    id: 79,
    title: 'Photography',
    category: 'photo',
    subcategory: 'social',
    image: 'https://lh3.googleusercontent.com/d/1DrgBMMySw6qYRqLD5Rman_fX6mrXnKwa',
    description: 'Magazine layout & editorial design for a lifestyle publication, focusing on clean typography and visual storytelling.',
    tags: ['Editorial', 'Layout', 'Typography', 'Print'],
  },
  {
    id: 80,
    title: 'Photography',
    category: 'photo',
    subcategory: 'social',
    image: 'https://lh3.googleusercontent.com/d/1PA7mgJ-gRK5jBW3iFRqv3iA9nTR8jt73',
    description: 'Magazine layout & editorial design for a lifestyle publication, focusing on clean typography and visual storytelling.',
    tags: ['Editorial', 'Layout', 'Typography', 'Print'],
  },
  {
    id: 81,
    title: 'Photography',
    category: 'photo',
    subcategory: 'social',
    image: 'https://lh3.googleusercontent.com/d/1BTcp3-qRcnLe58moK2m_fevD4y15PynW',
    description: 'Magazine layout & editorial design for a lifestyle publication, focusing on clean typography and visual storytelling.',
    tags: ['Editorial', 'Layout', 'Typography', 'Print'],
  },
  {
    id: 82,
    title: 'Photography',
    category: 'photo',
    subcategory: 'social',
    image: 'https://lh3.googleusercontent.com/d/1bJcMpFzr9SAjS73UqyTq6Vks9pePyAPJ',
    description: 'Magazine layout & editorial design for a lifestyle publication, focusing on clean typography and visual storytelling.',
    tags: ['Editorial', 'Layout', 'Typography', 'Print'],
  },
  {
    id: 83,
    title: 'Photography',
    category: 'photo',
    subcategory: 'social',
    image: 'https://lh3.googleusercontent.com/d/1KsriVKtwMzS8zZu7Xc31j4Gvuo4aBA4O',
    description: 'Magazine layout & editorial design for a lifestyle publication, focusing on clean typography and visual storytelling.',
    tags: ['Editorial', 'Layout', 'Typography', 'Print'],
  },
  {
    id: 84,
    title: 'Photography',
    category: 'photo',
    subcategory: 'social',
    image: 'https://lh3.googleusercontent.com/d/1wV9tvuySaqWS77DDoXBkex5V_w59lvX0',
    description: 'Magazine layout & editorial design for a lifestyle publication, focusing on clean typography and visual storytelling.',
    tags: ['Editorial', 'Layout', 'Typography', 'Print'],
  },
  {
    id: 85,
    title: 'Photography',
    category: 'photo',
    subcategory: 'social',
    image: 'https://lh3.googleusercontent.com/d/1Z6CcLHaB1bWZSppLOtGUYn62DKcynz7j',
    description: 'Award-winning minimalist poster design series exploring form, color, and negative space.',
    tags: ['Poster', 'Minimal', 'Typography', 'Design'],
  },
  {
    id: 86,
    title: 'Photography',
    category: 'photo',
    subcategory: 'corporate',
    image: 'https://lh3.googleusercontent.com/d/1GGH1F3iY2bx7UrsfGAROVMZrrs0uLKfq',
    description: 'Sustainable packaging design for an eco‑friendly skincare brand, using recycled materials and natural tones.',
    tags: ['Packaging', 'Sustainable', 'Branding', 'Product'],
  },
  {
    id: 87,
    title: 'Photography',
    category: 'photo',
    subcategory: 'social',
    image: 'https://lh3.googleusercontent.com/d/1YtczHYYmxuv77fp4bhR6h_YsfZDK55TB',
    description: 'A self‑published zine documenting street art culture in Berlin, with bold typography and experimental layouts.',
    tags: ['Zine', 'Street Art', 'Layout', 'Urban'],
  },
  {
    id: 88,
    title: 'Photography',
    category: 'photo',
    subcategory: 'corporate',
    image: 'https://lh3.googleusercontent.com/d/1DvX3IwBMDa_JkUKW3q7biXuJ6suDz0Lw',
    description: 'User interface design for a SaaS platform, focusing on clarity, accessibility, and modern aesthetics.',
    tags: ['UI', 'Web', 'UX', 'SaaS'],
  },
  {
    id: 89,
    title: 'Photography',
    category: 'photo',
    subcategory: 'corporate',
    image: 'https://lh3.googleusercontent.com/d/1uHIL933fpwQ5m4O1HjJr7O-Kr1mCjJ0I',
    description: 'Rebranding of a record store chain, blending retro and contemporary design elements.',
    tags: ['Rebrand', 'Retro', 'Logo', 'Typography'],
  },
  {
    id: 90,
    title: 'Photography',
    category: 'photo',
    subcategory: 'social',
    image: 'https://lh3.googleusercontent.com/d/1_dy9C8nic7w2Y_WLQnZolpEoTI0pEupq',
    description: 'Informative infographic visualizing climate data, designed for a non‑profit campaign.',
    tags: ['Infographic', 'Data', 'Non‑profit', 'Editorial'],
  },
  {
    id: 91,
    title: 'Photography',
    category: 'photo',
    subcategory: 'social',
    image: 'https://lh3.googleusercontent.com/d/1DzCa1AcLr9sihXnvuYi-BEC9NSoE3BRB',
    description: 'Informative infographic visualizing climate data, designed for a non‑profit campaign.',
    tags: ['Infographic', 'Data', 'Non‑profit', 'Editorial'],
  },
  {
    id: 92,
    title: 'Photography',
    category: 'photo',
    subcategory: 'real-estate',
    image: 'https://lh3.googleusercontent.com/d/1QnmvxtWCDF31KkjZy5EgSIRMYEtZeWO_',
    description: 'A curated mood board for a luxury interior design project, featuring color palettes and material samples.',
    tags: ['Mood Board', 'Interior', 'Style', 'Inspiration'],
  },
  {
    id: 93,
    title: 'Photography',
    category: 'photo',
    subcategory: 'real-estate',
    image: 'https://lh3.googleusercontent.com/d/1IQp6iG1z3Plg1UImiuLA5zjo18szxW8u',
    description: 'A curated mood board for a luxury interior design project, featuring color palettes and material samples.',
    tags: ['Mood Board', 'Interior', 'Style', 'Inspiration'],
  },
  {
    id: 94,
    title: 'Photography',
    category: 'photo',
    subcategory: 'real-estate',
    image: 'https://lh3.googleusercontent.com/d/1qYDJEE9hjMM8RojFhAyPfCEK89B8vXdY',
    description: 'A curated mood board for a luxury interior design project, featuring color palettes and material samples.',
    tags: ['Mood Board', 'Interior', 'Style', 'Inspiration'],
  },
  {
    id: 95,
    title: 'Photography',
    category: 'photo',
    subcategory: 'real-estate',
    image: 'https://lh3.googleusercontent.com/d/1DcDNbAWVvJq8WIXhFuLZ81312k31WFHB',
    description: 'A curated mood board for a luxury interior design project, featuring color palettes and material samples.',
    tags: ['Mood Board', 'Interior', 'Style', 'Inspiration'],
  },
  {
    id: 96,
    title: 'Photography',
    category: 'photo',
    subcategory: 'real-estate',
    image: 'https://lh3.googleusercontent.com/d/1jYI1vCbklNl4syw1YLGfosqoUlxf4qv3',
    description: 'A curated mood board for a luxury interior design project, featuring color palettes and material samples.',
    tags: ['Mood Board', 'Interior', 'Style', 'Inspiration'],
  },
  {
    id: 97,
    title: 'Photography',
    category: 'photo',
    subcategory: 'real-estate',
    image: 'https://lh3.googleusercontent.com/d/1lauQ0I-1mmehO15Nifaeh52yxPUhug6K',
    description: 'A curated mood board for a luxury interior design project, featuring color palettes and material samples.',
    tags: ['Mood Board', 'Interior', 'Style', 'Inspiration'],
  },
  {
    id: 98,
    title: 'Photography',
    category: 'photo',
    subcategory: 'real-estate',
    image: 'https://lh3.googleusercontent.com/d/14fJ9MYHx6aaTN3L-ub0uz7uo4tyIkpN9',
    description: 'A curated mood board for a luxury interior design project, featuring color palettes and material samples.',
    tags: ['Mood Board', 'Interior', 'Style', 'Inspiration'],
  },
  {
    id: 99,
    title: 'Photography',
    category: 'photo',
    subcategory: 'real-estate',
    image: 'https://lh3.googleusercontent.com/d/1UxjnpQ17WF3aP69WE6kPiegyRWNHZiwf',
    description: 'A curated mood board for a luxury interior design project, featuring color palettes and material samples.',
    tags: ['Mood Board', 'Interior', 'Style', 'Inspiration'],
  },
  {
    id: 100,
    title: 'Photography',
    category: 'photo',
    subcategory: 'real-estate',
    image: 'https://lh3.googleusercontent.com/d/1ecKwqmWlHAn1z3B52_P7r-AQNkW3o56r',
    description: 'A curated mood board for a luxury interior design project, featuring color palettes and material samples.',
    tags: ['Mood Board', 'Interior', 'Style', 'Inspiration'],
  },
  {
    id: 101,
    title: 'Photography',
    category: 'photo',
    subcategory: 'real-estate',
    image: 'https://lh3.googleusercontent.com/d/19RtNXlEfyk0c0halaX1zv9w8Rgz5haC_',
    description: 'A curated mood board for a luxury interior design project, featuring color palettes and material samples.',
    tags: ['Mood Board', 'Interior', 'Style', 'Inspiration'],
  },
  {
    id: 102,
    title: 'Photography',
    category: 'photo',
    subcategory: 'real-estate',
    image: 'https://lh3.googleusercontent.com/d/1c-gZ_hLiPDJy_vIrZTjP-UbOtrJlijMx',
    description: 'A curated mood board for a luxury interior design project, featuring color palettes and material samples.',
    tags: ['Mood Board', 'Interior', 'Style', 'Inspiration'],
  },
  {
    id: 103,
    title: 'Photography',
    category: 'photo',
    subcategory: 'real-estate',
    image: 'https://lh3.googleusercontent.com/d/1oendjZZSQzzPeZlR_7KVs_XZog5ExO85',
    description: 'A curated mood board for a luxury interior design project, featuring color palettes and material samples.',
    tags: ['Mood Board', 'Interior', 'Style', 'Inspiration'],
  },
  {
    id: 104,
    title: 'Photography',
    category: 'photo',
    subcategory: 'real-estate',
    image: 'https://lh3.googleusercontent.com/d/1JRT-Qu43XXNmnv6dpZ24fCnAbHVzujDP',
    description: 'A curated mood board for a luxury interior design project, featuring color palettes and material samples.',
    tags: ['Mood Board', 'Interior', 'Style', 'Inspiration'],
  },
  {
    id: 105,
    title: 'Photography',
    category: 'photo',
    subcategory: 'real-estate',
    image: 'https://lh3.googleusercontent.com/d/1xO-TCFlzj60-Sbx5aeUnbZ6y40UpKW9d',
    description: 'A curated mood board for a luxury interior design project, featuring color palettes and material samples.',
    tags: ['Mood Board', 'Interior', 'Style', 'Inspiration'],
  },
  {
    id: 106,
    title: 'Photography',
    category: 'photo',
    subcategory: 'real-estate',
    image: 'https://lh3.googleusercontent.com/d/1wJtr6HV5B10MeTdFfcWZuAg9A1gXE0Fl',
    description: 'A curated mood board for a luxury interior design project, featuring color palettes and material samples.',
    tags: ['Mood Board', 'Interior', 'Style', 'Inspiration'],
  },
  {
    id: 107,
    title: 'Photography',
    category: 'photo',
    subcategory: 'real-estate',
    image: 'https://lh3.googleusercontent.com/d/1bd5_Pxaoz41_VY96tPmn_iOmFL2kQ4dW',
    description: 'A curated mood board for a luxury interior design project, featuring color palettes and material samples.',
    tags: ['Mood Board', 'Interior', 'Style', 'Inspiration'],
  },
  {
    id: 108,
    title: 'Photography',
    category: 'photo',
    subcategory: 'real-estate',
    image: 'https://lh3.googleusercontent.com/d/1ED2oEJYbGBbIMpfdwGyaPwYF4_IXIWi0',
    description: 'A curated mood board for a luxury interior design project, featuring color palettes and material samples.',
    tags: ['Mood Board', 'Interior', 'Style', 'Inspiration'],
  },
  {
    id: 109,
    title: 'Photography',
    category: 'photo',
    subcategory: 'real-estate',
    image: 'https://lh3.googleusercontent.com/d/1lcsDyn5wCm0UkAkuwvtORmhdr_B8oqSq',
    description: 'A curated mood board for a luxury interior design project, featuring color palettes and material samples.',
    tags: ['Mood Board', 'Interior', 'Style', 'Inspiration'],
  },
  {
    id: 110,
    title: 'Photography',
    category: 'photo',
    subcategory: 'real-estate',
    image: 'https://lh3.googleusercontent.com/d/1ti7054H01o2YBXcQKX5sXZ1DDEGhomkB',
    description: 'A curated mood board for a luxury interior design project, featuring color palettes and material samples.',
    tags: ['Mood Board', 'Interior', 'Style', 'Inspiration'],
  },
  {
    id: 111,
    title: 'Photography',
    category: 'photo',
    subcategory: 'real-estate',
    image: 'https://lh3.googleusercontent.com/d/1WBK6941LSg6uZmQ9CuD1xSWKtS7qHVIJ',
    description: 'A curated mood board for a luxury interior design project, featuring color palettes and material samples.',
    tags: ['Mood Board', 'Interior', 'Style', 'Inspiration'],
  },
  {
    id: 112,
    title: 'Photography',
    category: 'photo',
    subcategory: 'social',
    image: 'https://lh3.googleusercontent.com/d/1FZZzW14fcK3R-Tu9tW2otj0tz2Inqk8t',
    description: 'Cover design for a book on typography history, using classic typefaces and modern composition.',
    tags: ['Book Cover', 'Typography', 'Editorial', 'Design'],
  },

  // ─── Motion Graphics (10) ───
  {
    id: 113,
    title: 'Urban Dreams — Short Film',
    category: 'motion',
    image: 'https://lh3.googleusercontent.com/d/1ee2Jbnqz2_eKvxLSWc5nlxYeybeQJV9H',
    description: 'A cinematic short film exploring the rhythm and energy of city life through visual storytelling.',
    tags: ['Cinematography', 'Editing', 'Color Grading', 'Directing'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1ee2Jbnqz2_eKvxLSWc5nlxYeybeQJV9H',
        embed: 'https://drive.google.com/file/d/1ee2Jbnqz2_eKvxLSWc5nlxYeybeQJV9H',
        title: 'Motion Graphics',
      },
    ],
  },
  {
    id: 114,
    title: 'Ethereal Music Video',
    category: 'motion',
    image: 'https://lh3.googleusercontent.com/d/1Y6kjL-5FWFbqIjUZufr6TCY32i-JQJqp',
    description: 'Music video for an independent artist, blending abstract visuals with live performance footage.',
    tags: ['Direction', 'VFX', 'Editing', 'Color Grading'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1Y6kjL-5FWFbqIjUZufr6TCY32i-JQJqp',
        embed: 'https://drive.google.com/file/d/1Y6kjL-5FWFbqIjUZufr6TCY32i-JQJqp/preview',
        title: 'Motion Graphics',
      },
    ],
  },
  {
    id: 115,
    title: 'Wanderlust — Travel Documentary',
    category: 'motion',
    image: 'https://lh3.googleusercontent.com/d/15QzCZd9yucSsC_nRoFMCW9nJBuSJDXVQ',
    description: 'Documentary exploring remote landscapes and the people who call them home.',
    tags: ['Documentary', 'Cinematography', 'Sound Design', 'Editing'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/15QzCZd9yucSsC_nRoFMCW9nJBuSJDXVQ',
        embed: 'https://drive.google.com/file/d/15QzCZd9yucSsC_nRoFMCW9nJBuSJDXVQ/preview',
        title: 'Motion Graphics',
      },
    ],
  },
  {
    id: 116,
    title: 'Brand Film — Lumina',
    category: 'motion',
    image: 'https://lh3.googleusercontent.com/d/1w5jDgeGTnMOfJ42fU-97FykQJL_wpiu4',
    description: 'A cinematic brand film for a tech company, highlighting innovation and human connection.',
    tags: ['Brand Film', 'Cinematography', 'Storytelling', 'Editing'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1w5jDgeGTnMOfJ42fU-97FykQJL_wpiu4',
        embed: 'https://drive.google.com/file/d/1w5jDgeGTnMOfJ42fU-97FykQJL_wpiu4/preview',
        title: 'Motion Graphics',
      },
    ],
  },
  {
    id: 117,
    title: 'Dance Performance — Live Recording',
    category: 'motion',
    image: 'https://lh3.googleusercontent.com/d/1mJma_v7pbNPFSi99JrVarF0KD_DDMo1U',
    description: 'Live recording of a contemporary dance performance, capturing movement and emotion.',
    tags: ['Live Performance', 'Cinematography', 'Editing', 'Sound'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1mJma_v7pbNPFSi99JrVarF0KD_DDMo1U',
        embed: 'https://drive.google.com/file/d/1mJma_v7pbNPFSi99JrVarF0KD_DDMo1U/preview',
        title: 'Motion Graphics',
      },
    ],
  },
  {
    id: 118,
    title: 'Commercial — Organic Food',
    category: 'motion',
    image: 'https://lh3.googleusercontent.com/d/1EaemMmtjIIRK2rtF3HojUnqZhHSgQbM4',
    description: 'A mouth‑watering commercial for an organic food brand, shot in natural daylight.',
    tags: ['Commercial', 'Food', 'Cinematography', 'Editing'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1EaemMmtjIIRK2rtF3HojUnqZhHSgQbM4',
        embed: 'https://drive.google.com/file/d/1EaemMmtjIIRK2rtF3HojUnqZhHSgQbM4/preview',
        title: 'Motion Graphics',
      },
    ],
  },
  {
    id: 119,
    title: 'Fashion Lookbook — Spring Collection',
    category: 'motion',
    image: 'https://lh3.googleusercontent.com/d/1VPkiRIFilV-6WY30XBI3NlPkpCkmABDn',
    description: 'A dynamic lookbook video showcasing a fashion brand’s spring collection, with slow motion and vibrant colors.',
    tags: ['Fashion', 'Lookbook', 'Cinematography', 'Editing'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1VPkiRIFilV-6WY30XBI3NlPkpCkmABDn',
        embed: 'https://drive.google.com/file/d/1VPkiRIFilV-6WY30XBI3NlPkpCkmABDn/preview',
        title: 'Motion Graphics',
      },
    ],
  },
  {
    id: 120,
    title: 'Travel Vlog — Japan',
    category: 'motion',
    image: 'https://lh3.googleusercontent.com/d/1rHD-QysQnDcjKr0z55A0-W0VUP87-Twe',
    description: 'A personal travel vlog documenting a journey through Japan, capturing culture, food, and scenery.',
    tags: ['Travel', 'Vlog', 'Editing', 'Cinematography'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1rHD-QysQnDcjKr0z55A0-W0VUP87-Twe',
        embed: 'https://drive.google.com/file/d/1rHD-QysQnDcjKr0z55A0-W0VUP87-Twe/preview',
        title: 'Motion Graphics',
      },
    ],
  },
  {
    id: 121,
    title: 'Promo — Tech Conference',
    category: 'motion',
    image: 'https://lh3.googleusercontent.com/d/1s72AYqHuNi89ZFVLOpsP4rl8StvUllWB',
    description: 'Promotional video for a tech conference, with fast‑paced editing and speaker highlights.',
    tags: ['Promo', 'Event', 'Editing', 'Motion Graphics'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1s72AYqHuNi89ZFVLOpsP4rl8StvUllWB',
        embed: 'https://drive.google.com/file/d/1s72AYqHuNi89ZFVLOpsP4rl8StvUllWB/preview',
        title: 'Motion Graphics',
      },
    ],
  },
  {
    id: 122,
    title: 'Documentary — Ocean Conservation',
    category: 'motion',
    image: 'https://lh3.googleusercontent.com/d/1h4J2viKAZwqzdZly_H7nsFf_wf_Qtnhf',
    description: 'A short documentary highlighting ocean conservation efforts, with underwater footage and expert interviews.',
    tags: ['Documentary', 'Conservation', 'Cinematography', 'Editing'],
    media: [
      {
        type: 'video',
        thumbnail: 'https://lh3.googleusercontent.com/d/1h4J2viKAZwqzdZly_H7nsFf_wf_Qtnhf',
        embed: 'https://drive.google.com/file/d/1h4J2viKAZwqzdZly_H7nsFf_wf_Qtnhf',
        title: 'Motion Graphics',
      },
    ],
  },
];

export const SERVICES = [
  {
    icon: 'Palette',
    title: 'Graphic Design',
    description: 'Visuals that make your message impossible to ignore.',
    longDescription: 'From brand identities and campaign graphics to social media content, presentations, posters, and marketing collateral, I create designs that combine clarity, creativity, and consistency.',
    videoEmbed: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    features: ['Brand Identity', 'Campaign Graphics', 'Social Media', 'Presentations'],
    filterValue: 'graphic',
  },
  {
    icon: 'Layers',
    title: 'Motion Design',
    description: 'Make your ideas move.',
    longDescription: 'I transform static visuals into engaging motion graphics and animated content designed to capture attention and communicate ideas quickly.',
    videoEmbed: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    features: ['2D Animation', 'Motion Graphics', 'Title Sequences', 'Explainer Videos'],
    filterValue: 'motion',
  },
  {
    icon: 'Video',
    title: 'Videography',
    description: 'Capture the moment. Tell the story.',
    longDescription: 'From events and corporate content to campaigns and creative productions, I create intentional video footage that gives stories a visual voice.',
    videoEmbed: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    features: ['Event Coverage', 'Corporate Content', 'Campaigns', 'Creative Production'],
    filterValue: 'video',
  },
  {
    icon: 'Video',
    title: 'Video Editing',
    description: 'Raw footage becomes a story in the edit.',
    longDescription: 'I shape footage into engaging visual narratives through editing, pacing, transitions, sound, colour, motion graphics, and storytelling.',
    videoEmbed: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    features: ['Editing', 'Colour Grading', 'Sound Design', 'Motion Graphics'],
    filterValue: 'video',
  },
  {
    icon: 'Camera',
    title: 'Photography',
    description: 'Moments captured with intention.',
    longDescription: 'Portraits, events, products, lifestyle, and corporate photography created to communicate personality, atmosphere, and story.',
    videoEmbed: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    features: ['Portraits', 'Events', 'Products', 'Lifestyle'],
    filterValue: 'photo',
  },
  {
    icon: 'Camera',
    title: 'Photo Editing',
    description: 'Every image has room to become better.',
    longDescription: 'From professional retouching and colour correction to compositing and creative manipulation, I refine images while maintaining their character and purpose.',
    videoEmbed: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    features: ['Retouching', 'Colour Correction', 'Compositing', 'Creative Manipulation'],
    filterValue: 'photo',
  },
];

export const SERVICES_HOME = [
  {
    icon: 'Palette',
    title: 'Graphic Design',
    description: 'Creating purposeful visual identities, campaign materials, digital content, layouts, and communication assets.',
    longDescription: 'I design visual identities, marketing materials, and digital content that communicate clearly and leave a lasting impression. From logos to full brand systems, every detail is crafted with intention.',
    videoEmbed: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    features: ['Brand Identity', 'Print & Digital', 'Layout Design', 'Campaign Assets'],
    filterValue: 'graphic',
  },
  {
    icon: 'Video',
    title: 'Videography',
    description: 'Capturing people, products, events, and stories through intentional visual direction and production.',
    longDescription: 'I bring stories to life through the lens. Whether it’s a brand film, a music video, or a documentary, I handle every stage – from concept to final edit.',
    videoEmbed: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    features: ['Cinematography', 'Production', 'Lighting', 'Sound Recording'],
    filterValue: 'video',
  },
  // {
  //   icon: 'Video',
  //   title: 'Video Editing',
  //   description: 'Transforming raw footage into engaging stories through editing, pacing, sound, transitions, colour, and narrative structure.',
  //   longDescription: 'I edit videos to tell a clear, compelling story. I handle pacing, transitions, colour grading, sound design, and all post‑production to deliver a polished final product.',
  //   videoEmbed: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
  //   features: ['Editing', 'Colour Grading', 'Sound Design', 'Transitions'],
  //   filterValue: 'video',
  // },
  // {
  //   icon: 'Layers',
  //   title: 'Motion Design',
  //   description: 'Bringing static ideas to life through animation, motion graphics, transitions, and dynamic visual storytelling.',
  //   longDescription: 'I create animated explainers, dynamic title sequences, and social media motion graphics that capture attention and communicate your message with energy.',
  //   videoEmbed: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
  //   features: ['2D Animation', 'Motion Graphics', 'Title Sequences', 'Explainer Videos'],
  //   filterValue: 'motion',
  // },
  {
    icon: 'Camera',
    title: 'Photography',
    description: 'Creating expressive and purposeful imagery across portraits, events, products, lifestyle, and corporate content.',
    longDescription: 'I capture authentic moments with a focus on composition, lighting, and emotion. Whether it’s a portrait session, product shoot, or event coverage, I deliver images that resonate.',
    videoEmbed: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    features: ['Portraits', 'Products', 'Events', 'Lifestyle'],
    filterValue: 'photo',
  },
  // {
  //   icon: 'Camera',
  //   title: 'Photo Editing',
  //   description: 'Refining images through retouching, colour correction, manipulation, compositing, and visual enhancement.',
  //   longDescription: 'I enhance and retouch photos to ensure they look professional and polished. From colour correction to detailed retouching, I bring out the best in every image.',
  //   videoEmbed: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
  //   features: ['Retouching', 'Colour Correction', 'Compositing', 'Enhancement'],
  //   filterValue: 'photo',
  // },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: 'Sarah Chen',
    role: 'CEO, Lumina Tech',
    content: 'Working with Aria transformed our brand identity. The attention to detail and creative vision is unmatched.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1494790108375-be9c55b6ee30?w=80&h=80&fit=crop&crop=face',
  },
  {
    id: 2,
    name: 'Michael Torres',
    role: 'Film Director',
    content: 'The videography work on my latest project was nothing short of phenomenal. Professional, creative, and delivered ahead of schedule.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop&crop=face',
  },
  {
    id: 3,
    name: 'Emily Watson',
    role: 'Marketing Director, Vivid Co',
    content: 'The design work elevated our entire marketing campaign. We saw a 40% increase in engagement across all channels.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=face',
  },
];

export const NAV_ITEMS = ['Home', 'About', 'Services', 'Portfolio', 'Shop', 'Contact'];
// export const NAV_ITEMS = ['Home', 'About', 'Services', 'Portfolio', 'Shop', 'Blog', 'Contact'];